import React from 'react';
import styled from 'styled-components';

import { Typography } from 'src/typography';
import { WhiteLabelLogo } from 'src/payments/components';
import { PayByBankLogo } from 'src/assets/pay-by-bank-logo';
import { DUTCHIE_PAY } from 'src/payments/constants';
import { WhiteLabelConfig } from 'src/payments/hooks';

const NO_FEE = '($0 Fee)';

export const PaymentHeader = ({
  paymentValue,
  paymentLabel,
  paymentFee,
  whiteLabelConfig,
}: {
  paymentValue: string;
  paymentLabel: string;
  paymentFee: string;
  whiteLabelConfig: WhiteLabelConfig;
}): JSX.Element => {
  const renderPaymentHeader = (): JSX.Element => {
    if (paymentValue === DUTCHIE_PAY) {
      return whiteLabelConfig.useWhiteLabel ? (
        <WhiteLabelLogo variant='dark' height='13' />
      ) : (
        <PayByBankLogo style={{ marginTop: '2px' }} width='77' height='13' />
      );
    }
    return (
      <CreditCardText weight='semi' size='medium'>
        {paymentLabel}
      </CreditCardText>
    );
  };

  return (
    <HeaderTextContainer>
      {renderPaymentHeader()}
      <FeeText size='medium'>{paymentFee || NO_FEE}</FeeText>
    </HeaderTextContainer>
  );
};

const HeaderTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces[2]};
`;

const CreditCardText = styled(Typography.Body)`
  color: ${({ theme }) => theme.colors.grey[25]};
  line-height: 20px;
`;

const FeeText = styled(Typography.Body)`
  color: #646d72;
  line-height: 20px;
`;
